import React from 'react';
import PropTypes from 'prop-types';

const Trend = props => {
  const { color, width, height, ...other } = props;

  return (
    <svg width={width} height={height} viewBox="0 0 18 18" version="1.1" xmlns="http://www.w3.org/2000/svg" {...other}>
      <rect width="18" height="18" fill="none" />
      <path id="Path-3" d="M10.693,15.886l4.386-6.58a.563.563,0,0,0-.468-.875H11.163V4.29a.562.562,0,0,0-1.031-.312l-4.386,6.58a.563.563,0,0,0,.468.875H9.663v4.142a.562.562,0,0,0,1.031.312Z" transform="translate(-1.413 -0.932)" fillRule="evenodd" fill={color} />
    </svg>
  );
}

Trend.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

Trend.defaultProps = {
  color: '#D6B330',
  width: 18,
  height: 18,
};

export default Trend;



// WEBPACK FOOTER //
// ./src/components/Icons/Trend.jsx